import { LoadAppVisibilitySuccess } from './reducer';
import { AppSettingsActionTypes, IAppVisibilityDetails } from './types';

export function LoadAppSettingsSuccessAction(app: IAppVisibilityDetails) {
  return LoadAppVisibilitySuccess({
    type: AppSettingsActionTypes.LOAD_APPSETTINGS_SUCCESS,
    app,
  });
}
